import { isPortalHostname } from "@v1/backend/logic/portal/portal_host";

/** Staff / marketing sign-in route. */
export const STAFF_SIGN_IN_PATH = "/login";

/** Portal tenants sign in at the site root (no `/login` URL on portal hosts). */
export const PORTAL_SIGN_IN_PATH = "/";

export function resolveSignInPathForPortalEntry(
  isPortalEntry: boolean,
): string {
  return isPortalEntry ? PORTAL_SIGN_IN_PATH : STAFF_SIGN_IN_PATH;
}

/** Client-side sign-in path; prefers `data-portal-entry` set by the root layout. */
export function resolveClientSignInPath(): string {
  if (typeof document === "undefined") return STAFF_SIGN_IN_PATH;
  if (document.documentElement.dataset.portalEntry === "true") {
    return PORTAL_SIGN_IN_PATH;
  }
  if (typeof window !== "undefined" && isPortalHostname(window.location.host)) {
    return PORTAL_SIGN_IN_PATH;
  }
  return STAFF_SIGN_IN_PATH;
}

export function isPortalEntryClient(): boolean {
  return resolveClientSignInPath() === PORTAL_SIGN_IN_PATH;
}
